
import { Injectable } from '@angular/core';
import { Resolve, ActivatedRouteSnapshot } from '@angular/router';
import { of, Observable } from 'rxjs';
import { ListingService } from '@app/core/services/listing.service';
import { tap, take } from 'rxjs/operators';

@Injectable()
export class ListingDetailsResolver implements Resolve<any> {
  constructor(private listingService: ListingService) { }
  resolve(route: ActivatedRouteSnapshot): Observable<any> {
    const listingID = route.params.listingID;
    return this.listingService
      .getListingDetails(listingID)
      .pipe(
        tap(
          data => {
            let item = {};
            const id = 'id';
            item = data;
            item[id] = listingID;
            return item;
          }),
        take(1)
      );
  }
}
